// Get Merchant
export const GET_MERCHANTS_REQUEST = 'GET_MERCHANTS_REQUEST';
export const GET_MERCHANTS_DONE = 'GET_MERCHANTS_DONE';
export const GET_MERCHANTS_FAILED = 'GET_MERCHANTS_FAILED';

// Delete Merchant
export const DELETE_MERCHANT_REQUEST = 'DELETE_MERCHANT_REQUEST';
export const DELETE_MERCHANT_DONE = 'DELETE_MERCHANT_DONE';
export const DELETE_MERCHANT_FAILED = 'DELETE_MERCHANT_FAILED';

// Save Columns Width
export const SAVE_MERCHANTS_COLUMNS = 'SAVE_MERCHANTS_COLUMNS';

// Operations
export const MERCHANTS_SET_PAGE = 'MERCHANTS_SET_PAGE';